$(function(){
  // modal
  $('.popup-youtube').magnificPopup({
    type: 'iframe'
  });


  
  if (window.matchMedia('(max-width: 999px)').matches) {
    $('button.header-sidebar__linklist-button').each(function(){
      var id = "#" + $(this).attr('aria-controls');
      $(id).insertAfter($(this));
    });
    $('button.header-sidebar__linklist-button').on('click',function(){
      $(this).toggleClass('open');
      $(this).next().slideToggle();
    });

    // 初期展開
    $('#header-panel-3 details').attr('open', true);
  
    var state = false;
    var pos;
    $('.header__primary-nav').on('click',function(){
      scroll = $(window).scrollTop();
      if($(this).hasClass('open')) {
        $(this).removeClass('open');
        $('header').removeClass('open');
        $('#sidebar-menu').removeClass('open');
        $('#sidebar-menu').fadeOut();
      } else {
        $(this).addClass('open');
        $('.fixed_menu').addClass('open');
        $('#sidebar-menu').addClass('open');
        $('#sidebar-menu').fadeIn();
      };
      if(state == false) {
        pos = $(window).scrollTop();
        $('body').addClass('fixed');
        state = true;
      } else {
        $('body').removeClass('fixed');
        window.scrollTo(0, pos);
        state = false;
      };
    });
  }


  // product-card slide----------------------------------------------------
  $('.og-product-card').each(function() {
    var $card = $(this);
  
    var thumbSwiperEl = $card.find('.media_sub.swiper')[0];
    var mediaSwiperEl = $card.find('.media_main.swiper')[0];
  
    if (thumbSwiperEl && mediaSwiperEl) {
      // 先にThumbSwiperを作る
      var thumbSwiper = new Swiper(thumbSwiperEl, {
        slidesPerView: 'auto',
        watchSlidesProgress: true,
      });
  
      // 次にMediaSwiperを作って、ThumbSwiperと連動させる
      var mediaSwiper = new Swiper(mediaSwiperEl, {
        slidesPerView: 'auto',
        thumbs: {
          swiper: thumbSwiper
        }
      });
    }
  });

  
  // main-product spec----------------------------------------------------
  $('.product_spec_triger').on('click',function(){
    var target = $(this).prev('.product_spec').children('dd');
    if(target.hasClass('open')) {
      $(this).removeClass('open');
      $(this).children('span').text('続きを見る');
      target.removeClass('open');
    }else {
      $(this).addClass('open');
      $(this).children('span').text('閉じる');
      target.addClass('open');
    }
  });

  
});
